import { BehaviorSubject, mergeMap } from 'rxjs';
import { 
    fetchUserProfileEpic,
    saveFavoriteEpic, 
    deleteFavoriteEpic,
    fetchUserFavoritesEpic,
} from 'features/userProfile';
import { combineEpics } from 'redux-observable';

const combinedUserProfileEpic = combineEpics(
    fetchUserProfileEpic,
    saveFavoriteEpic,
    deleteFavoriteEpic,
    fetchUserFavoritesEpic,
    );
// Exports the Observable of 'epic' to allow other modules to dynamically register their epic.
export const epic$ = new BehaviorSubject(combinedUserProfileEpic);

export const rootEpic = (action$, state$) => epic$.pipe(mergeMap((epic) => epic(action$, state$)));